<template>
  <main class="mt-5">
    <span id="add-btn">
      <!-- <button @click="createItem" v-b-modal.admin class="btn btn-success">
        مدیر جدید
      </button> -->
    </span>
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold">مدیران</h5>
        <div style="flex:1"></div>
      </div>
      <div class="card-body">
        <div>
          <b-table
            responsive
            hover
            bordered
            :items="items.data"
            :fields="fields"
          >
            <!-- <template v-slot:cell(edit)="data">
              <span :id="'edit-btn-' + data.item.id">
                <a
                  class="action-btns1  pt-1 px-2"
                  @click="editItem(data.index)"
                >
                  <i class="feather feather-edit  text-primary"></i>
                </a>
              </span>
            </template> -->
            <template v-slot:cell(created_at)="data">
              {{ data.item.created_at | persianDate }}
            </template>
            <!-- <template v-slot:cell(delete)="data">
              <span :id="'delete-btn-' + data.item.id">
                <a
                  class="action-btns1  pt-1 px-2 "
                  @click="deleteItem(data.item.id)"
                >
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </span>
            </template> -->
          </b-table>
          <Loading v-if="$root.isEmptyObject(items)" />
          <pagination
            v-else-if="items.data != ''"
            :disabled="disabled"
            :limit="2"
            :data="items"
            @pagination-change-page="changePage"
          >
          </pagination>
          <div v-else class="alert alert-danger">
            موردی یافت نشد
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import AdminImpl from "@@/core/pages/Admin/AdminImpl";
export default {
  extends: AdminImpl,
};
</script>
